import React, { useCallback, useState } from "react";
import { useAppDispatch } from "../../../../../state/store";
import { keywordSearchAction } from "../../../../../state/usecase/admin/care_recipient/actions";

export const CareRecipientsSearch = React.memo(function CareRecipientsSearch() {
    const dispatch = useAppDispatch();

    const [searchKeyword, setSearchKeyWord] = useState("");

    const handleSearchEvent = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const keyword = event.target.value;

        setSearchKeyWord(keyword);

        dispatch(
            keywordSearchAction({ searchKeyword: keyword })
        );
    }, [dispatch]);

    return (
        <div className={"search_area"}>
            <input className={"text_box__input"} type="search" value={searchKeyword} onChange={handleSearchEvent} placeholder={"ハウスIDまたは氏名で検索"} />
        </div>
    );
});